// extracted by mini-css-extract-plugin
module.exports = {"container":"XL-z","noResults":"YL-z","contact":"ZL-z"};